<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      // requestType: 'GET',
    };
  },
  mounted() {
    this.getConfigList('dealer_scanning_reward_report_list');
  },
  methods: {
  },
};
</script>
